import { either, function as function_, json } from "fp-ts";
import { z } from "zod";
function transformJson(schema) {
    return (value, ctx)=>{
        const checkResult = function_.pipe(value, json.parse, either.map((value)=>schema.safeParse(value)));
        if (either.isLeft(checkResult)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `Failed to parse value as JSON. Cause: ${String(checkResult.left)}`
            });
            return z.NEVER;
        }
        if (checkResult.right.success) {
            return checkResult.right.data;
        } else {
            for (const issue of checkResult.right.error.issues){
                ctx.addIssue(issue);
            }
            return z.NEVER;
        }
    };
}
export { transformJson };

//# sourceMappingURL=transformers.js.map